//
// Module for Document Review - Review view
//
rs.module("content/system_/activity/documentreview/review",

    [
        "common/select-helper",
        "common/visibility"
    ],

    function (selectHelper, visibility) {

        // Initialize the module
        function initialize(jsSelectors, backendUrls, constants) {

            var form = $.js(jsSelectors.form);

            var documentNumber = form.js(jsSelectors.documentNumber);
            var cardHeader = form.js(jsSelectors.cardHeader, { required: false });
            var documentHeader = form.js(jsSelectors.documentHeader);
            var edmDocumentType = form.js(jsSelectors.edmDocumentType);
            var edmDocumentTypeHiddenInput = form.js(jsSelectors.edmDocumentTypeHiddenInput, { required: false });
            var originalEdmDocumentType = form.js(jsSelectors.originalEdmDocumentType);
            var edmDocumentTypeError = form.js(jsSelectors.edmDocumentTypeError, { multiple: true });
            var retainEdmDocumentType = form.js(jsSelectors.retainEdmDocumentType, { required: false });
            var edmDocumentInfoKey = form.js(jsSelectors.edmDocumentInfoKey);
            var edmDocumentInfoKeyHiddenInput = form.js(jsSelectors.edmDocumentInfoKeyHiddenInput, { required: false });
            var originalEdmDocumentInfoKey = form.js(jsSelectors.originalEdmDocumentInfoKey);
            var edmDocumentNameHiddenInput = form.js(jsSelectors.edmDocumentNameHiddenInput);
            var edmDocumentInfoKeyError = form.js(jsSelectors.edmDocumentInfoKeyError, { multiple: true });
            var edmDestination = form.js(jsSelectors.edmDestination);
            var formNumber = form.js(jsSelectors.formNumber, { required: false });
            var reviewAction = form.js(jsSelectors.reviewAction);
            var reviewActionError = form.js(jsSelectors.reviewActionError);
            var previousButton = form.js(jsSelectors.previousButton, { required: false });
            var nextButton = form.js(jsSelectors.nextButton, { required: false });
            var finishButton = form.js(jsSelectors.finishButton, { required: false });
            var pendingChanges = form.js(jsSelectors.pendingChanges, { required: false });
            var pendingIndex = form.js(jsSelectors.pendingIndex, { required: false });
            var pendingDelete = form.js(jsSelectors.pendingDelete, { required: false });
            var pendingExport = form.js(jsSelectors.pendingExport, { required: false });

            // get select helpers
            var edmDocumentTypeSelectHelper = selectHelper.getHelper(edmDocumentType);
            var edmDocumentInfoKeySelectHelper = selectHelper.getHelper(edmDocumentInfoKey);
            var reviewActionSelectHelper = selectHelper.getHelper(reviewAction);

            // previous/next button click handlers - advance the queue the appropriate direction
            previousButton.click(function () { advanceQueue(false); });
            nextButton.click(function () { advanceQueue(true); });

            // setup custom document form validation
            setupFormValidation();

            // EDM document type changed - reload EDM document names
            edmDocumentType.change(function () {

                // clear EDM document info
                edmDocumentNameHiddenInput.val("");
                edmDestination.val("");
                formNumber.val("");

                // clear errors
                edmDocumentTypeError.text("");
                edmDocumentInfoKeyError.text("");

                var selectedEdmDocumentType = edmDocumentType.val();

                if (selectedEdmDocumentType) {
                    edmDocumentInfoKeySelectHelper.loadOptionsFrom(
                        backendUrls.getEdmDocuments,
                        { edmDocumentType: selectedEdmDocumentType },
                        { withBlank: true }
                    );
                }
                else {
                    edmDocumentInfoKeySelectHelper.clearOptions();
                }
            });

            // EDM document info key changed - reload EDM document info
            edmDocumentInfoKey.change(function () {

                // clear errors
                edmDocumentInfoKeyError.text("");

                // set EDM document name hidden input
                edmDocumentNameHiddenInput.val($(this).find("option:selected").text());

                // get selected EDM document
                var selectedEdmDocumentInfoKey = edmDocumentInfoKey.val();

                // load document info
                if (selectedEdmDocumentInfoKey) {
                    $.ajax({
                        url: backendUrls.getEdmDocumentInfo,
                        data: {
                            edmDocumentType: edmDocumentType.val(),
                            edmDocumentInfoKey: selectedEdmDocumentInfoKey
                        },
                        success: function (result) {
                            edmDestination.val(result.destination);

                            if (formNumber.length > 0) {
                                formNumber.val(result.formNumber)
                            };
                        }
                    });
                }
                else {
                    edmDestination.val("");
                }
            });

            // review action changed - clear related errors
            reviewAction.change(function () {
                edmDocumentTypeError.text("");
                edmDocumentInfoKeyError.text("");
                reviewActionError.text("");
            });

            // sets up the rules by which the document form will be validated
            function setupFormValidation() {

                // get name attributes of elements to validate
                var edmDocumentTypeKey = edmDocumentType.attr("name");
                var edmDocumentInfoKeyKey = edmDocumentInfoKey.attr("name");
                var originalEdmDocumentTypeKey = originalEdmDocumentType.attr("name");
                var originalEdmDocumentInfoKeyKey = originalEdmDocumentInfoKey.attr("name");

                // build rules
                var edmDocumentTypeRule = {
                    required: {
                        depends: function (element) {
                            return !edmDocumentType.prop("disabled") && reviewAction.val() == constants.export;
                        }
                    }
                }

                var edmDocumentInfoKeyRule = {
                    required: {
                        depends: function (element) {
                            return !edmDocumentInfoKey.prop("disabled") && (reviewAction.val() == constants.export || edmDocumentType.val());
                        }
                    }
                }

                var originalEdmDocumentTypeRule = {
                    required: {
                        depends: function (element) {
                            return edmDocumentType.prop("disabled") && reviewAction.val() == constants.export;
                        }
                    }
                }

                var originalEdmDocumentInfoKeyRule = {
                    required: {
                        depends: function (element) {
                            return edmDocumentInfoKey.prop("disabled") && reviewAction.val() == constants.export;
                        }
                    }
                }

                // build rules object
                var customRules = {};
                customRules[edmDocumentTypeKey] = edmDocumentTypeRule;
                customRules[edmDocumentInfoKeyKey] = edmDocumentInfoKeyRule;
                customRules[originalEdmDocumentTypeKey] = originalEdmDocumentTypeRule;
                customRules[originalEdmDocumentInfoKeyKey] = originalEdmDocumentInfoKeyRule;

                // build messages object
                var customMessages = {};
                customMessages[edmDocumentTypeKey] = constants.documentTypeError;
                customMessages[edmDocumentInfoKeyKey] = constants.documentNameError;
                customMessages[originalEdmDocumentTypeKey] = constants.documentTypeError;
                customMessages[originalEdmDocumentInfoKeyKey] = constants.documentNameError;

                // setup form validation - this must happen before using form.valid()
                form.validate({
                    rules: customRules,
                    messages: customMessages,

                    // override default ":hidden" so we can validate hidden inputs
                    ignore: "",

                    errorPlacement: function (error, element) {

                        // get the existing error span used with asp-for
                        var errorContainer = $('span[data-valmsg-for="' + element.attr('name') + '"]');

                        if (errorContainer.length > 0) {
                            $(errorContainer).text(error.text());
                        }
                    }
                });
            }

            // try to advance the queue to the next document (either forward or backward)
            function advanceQueue(forward) {

                if (form.valid()) {

                    edmDocumentTypeError.text("");
                    edmDocumentInfoKeyError.text("");

                    $.ajax({
                        url: backendUrls.processDocument,
                        data: {
                            reviewSessionId: constants.reviewSessionId,
                            documentNumber: documentNumber.val(),
                            edmDocumentType: edmDocumentType.val(),
                            edmDocumentInfoKey: edmDocumentInfoKey.val(),
                            edmDocumentName: edmDocumentNameHiddenInput.val(),
                            reviewAction: reviewAction.val(),
                            advanceForward: forward,
                            retainEdmDocumentType: retainEdmDocumentType.is(":checked")
                        },
                        success: function (result) {

                            if (result.success) {

                                // update document number
                                documentNumber.val(result.documentNumber);

                                // update card header text
                                cardHeader.text("Document (" + result.documentNumber + " of " + constants.totalDocuments + ")");

                                // update document header values
                                $.ajax({
                                    url: backendUrls.getDocumentHeader,
                                    data: {
                                        reviewSessionId: constants.reviewSessionId,
                                        documentNumber: result.documentNumber
                                    },
                                    success: function (data) {
                                        documentHeader.html(data);
                                    }
                                });

                                // update EDM document type
                                edmDocumentTypeSelectHelper.setValue(result.edmDocumentType);
                                originalEdmDocumentType.val(result.edmDocumentType);

                                if (edmDocumentTypeHiddenInput.length > 0) {
                                    edmDocumentTypeHiddenInput.val(result.edmDocumentType);
                                }

                                // update EDM document name
                                edmDocumentNameHiddenInput.val(result.edmDocumentName);

                                // update EDM document info key
                                edmDocumentInfoKeySelectHelper.replaceOptions(result.edmDocuments, { withBlank: true, suppressChange: true });
                                originalEdmDocumentInfoKey.val(result.edmDocumentInfoKey);

                                if (edmDocumentInfoKeyHiddenInput.length > 0) {
                                    edmDocumentInfoKeyHiddenInput.val(result.edmDocumentInfoKey);
                                }

                                // update EDM destination
                                edmDestination.val(result.destination);

                                // update EDM form number
                                if (formNumber.length > 0) {
                                    formNumber.val(result.formNumber)
                                };

                                // update review action
                                reviewActionSelectHelper.setValue(result.reviewAction);

                                // update queue values
                                pendingChanges.text(result.pendingChangesCount);
                                pendingIndex.text(result.pendingIndexCount);
                                pendingDelete.text(result.pendingDeleteCount);
                                pendingExport.text(result.pendingExportCount);

                                // disable previous button if this is the first document in the queue
                                previousButton.setDisabled(result.documentNumber == 1);

                                // show either next or finish button (depending if this is the last document in the queue)
                                visibility.setVisible(nextButton, result.documentNumber != constants.totalDocuments);
                                visibility.setVisible(finishButton, result.documentNumber == constants.totalDocuments);
                            }
                        }
                    });
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);